import type {
  GetProjectByProjectIdMeetingAndMeetingIdApiResponse,
  PostProjectByProjectIdMeetingApiResponse,
  PostProjectByProjectIdMeetingNewSingleMeetingApiResponse,
  PutProjectByProjectIdMeetingNewMeetingInSeriesApiResponse,
} from "../../../../openapi";

export type MeetingDetails = GetProjectByProjectIdMeetingAndMeetingIdApiResponse;
export type MeetingListItem = PostProjectByProjectIdMeetingApiResponse["meetings"][number];
export type CreatedMeeting =
  | PostProjectByProjectIdMeetingNewSingleMeetingApiResponse
  | PutProjectByProjectIdMeetingNewMeetingInSeriesApiResponse;

export type MeetingSerieOption = {
  _id?: string;
  name?: string;
  status?: string;
};

export type ConnectedMeetingOption = {
  _id?: string;
  dateOfMeeting?: string | Date;
  isDeleted?: boolean;
};

export const getRefId = (ref?: string | { _id?: string } | null): string | undefined =>
  typeof ref === "string" ? ref : ref?._id;

export const getObjectRefName = (ref?: string | { name?: string } | null): string | undefined =>
  typeof ref === "string" ? undefined : ref?.name;

export const toMeetingSerieOption = (
  meetingSerie?: MeetingDetails["meetingSerie"] | MeetingListItem["meetingSerie"] | null,
): MeetingSerieOption | undefined => {
  if (meetingSerie == null || typeof meetingSerie === "string") {
    return undefined;
  }

  return {
    _id: meetingSerie._id,
    name: meetingSerie.name,
    status: "status" in meetingSerie ? meetingSerie.status : undefined,
  };
};
